const ClientSelect: React.FC<{
  clients?: any[];
  selectedClientId?: string | null;
  setSelectedClient: (client: { id: string; name: string } | null) => void;
  isLoading?: boolean;
}> = ({ clients, selectedClientId, setSelectedClient, isLoading }) => {
  if (isLoading) {
    return (
      <div className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50">
        <span className="text-sm text-gray-500">Loading clients...</span>
      </div>
    );
  }

  if (!clients?.length) {
    return (
      <div className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50">
        <span className="text-sm text-gray-500">No clients found</span>
      </div>
    );
  }
  return (
    <div className="relative">
      <select
        className="w-full pl-3 pr-8 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm appearance-none bg-white"
        value={selectedClientId || ''}
        onChange={(e) => {
          const value = e.target.value === '' ? null : e.target.value;
          const selectedClient = value ? clients?.find((client) => client.id === value) : null;
          return setSelectedClient(selectedClient);
        }}
      >
        <option value="">Select a client to see the data...</option>
        {clients?.map((client) => (
          <option key={client.id} value={client.id}>
            {client.name}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
};

export default ClientSelect;
